"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restoreTokenAfter401 = exports.IGNORED_ERROR_NAME = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
exports.IGNORED_ERROR_NAME = "ignore";
const restoreTokenAfter401 = async (authService, error) => {
    const { response, config } = error;
    const originalRequest = config;
    if (response?.status === 401) {
        if (originalRequest.retryFlag) {
            await authService.logout();
        }
        else {
            try {
                originalRequest.retryFlag = true;
                originalRequest.headers.Authorization =
                    (0, utils_1.formatAuthToken)(await (0, utils_1.refreshToken)(authService));
                // retry original request
                return axios_1.default.request(originalRequest);
            }
            catch (err) {
                // failure due to auth0 not refreshing token, can happen if refresh token expires
                await authService.logout();
                // There is a time until the app is logs out, so we don't want to show the error.
                // To avoid this, we are marking the error so the UI and Sentry knows that
                // they don't have to show it
                // eslint-disable-next-line no-param-reassign
                error.name = exports.IGNORED_ERROR_NAME;
            }
        }
    }
    // return original error
    return Promise.reject(error);
};
exports.restoreTokenAfter401 = restoreTokenAfter401;
